import { vistoriasRecentes } from "@/mocks/dashboard";

const fitossanitarioColors: Record<string, string> = {
  bom: "bg-primary-100 text-primary-700",
  regular: "bg-warning-100 text-warning-700",
  ruim: "bg-danger-100 text-danger-700",
  critico: "bg-danger-200 text-danger-800",
  morta: "bg-secondary-200 text-secondary-700",
};

const fitossanitarioLabels: Record<string, string> = {
  bom: "Bom",
  regular: "Regular",
  ruim: "Ruim",
  critico: "Crítico",
  morta: "Morta",
};

const riscoColors: Record<string, string> = {
  baixo: "bg-primary-100 text-primary-700",
  medio: "bg-caution-100 text-caution-700",
  alto: "bg-warning-100 text-warning-700",
  critico: "bg-danger-100 text-danger-700",
};

const riscoLabels: Record<string, string> = {
  baixo: "Baixo",
  medio: "Médio",
  alto: "Alto",
  critico: "Crítico",
};

const statusColors: Record<string, string> = {
  concluida: "bg-primary-100 text-primary-700",
  pendente: "bg-warning-100 text-warning-700",
};

const statusLabels: Record<string, string> = {
  concluida: "Concluída",
  pendente: "Pendente",
};

export default function VistoriasTable() {
  return (
    <div className="bg-white rounded-card border border-background-200 overflow-hidden">
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        <div>
          <h3 className="text-sm font-semibold text-foreground-900 font-heading">Últimas Vistorias</h3>
          <p className="text-xs text-foreground-500 mt-0.5">Registros recentes de vistorias técnicas</p>
        </div>
        <a
          href="/vistorias"
          className="text-xs text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
        >
          Ver todas
          <i className="ri-arrow-right-line ml-1"></i>
        </a>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-t border-background-200">
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Código CTA</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Espécie</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Localização</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Estado Fitossanitário</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Risco</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Técnico</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Data</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500 whitespace-nowrap">Status</th>
            </tr>
          </thead>
          <tbody>
            {vistoriasRecentes.map((vist) => (
              <tr
                key={vist.id}
                className="border-t border-background-200 hover:bg-background-50 transition-colors cursor-pointer"
              >
                <td className="px-5 py-3">
                  <span className="text-sm font-medium text-foreground-900 font-mono">{vist.codigoCTA}</span>
                </td>
                <td className="px-5 py-3">
                  <span className="text-sm text-foreground-700">{vist.especie}</span>
                </td>
                <td className="px-5 py-3 max-w-[200px]">
                  <p className="text-sm text-foreground-700 truncate" title={vist.localizacao}>{vist.localizacao}</p>
                </td>
                <td className="px-5 py-3">
                  <span className={`badge ${fitossanitarioColors[vist.fitossanitario]}`}>
                    {fitossanitarioLabels[vist.fitossanitario]}
                  </span>
                </td>
                <td className="px-5 py-3">
                  <span className={`badge ${riscoColors[vist.risco]}`}>
                    {riscoLabels[vist.risco]}
                  </span>
                </td>
                <td className="px-5 py-3">
                  <span className="text-sm text-foreground-700 whitespace-nowrap">{vist.inspetor}</span>
                </td>
                <td className="px-5 py-3">
                  <span className="text-sm text-foreground-600 whitespace-nowrap">
                    {new Date(vist.data).toLocaleDateString("pt-BR")}
                  </span>
                </td>
                <td className="px-5 py-3">
                  <span className={`badge ${statusColors[vist.status]}`}>
                    {statusLabels[vist.status]}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}